import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { ColorPreviewItem } from 'containers/PanesPanel/selectors';

/**
 * Direct selector to the furnitureRibbon state domain
 */

const selectCabinetRibbonDomain = (state: ApplicationRootState) => {
  return state || initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by CabinetRibbon
 */

const makeSelectCabinetRibbon = () =>
  createSelector(selectCabinetRibbonDomain, substate => {
    return substate;
  });

export const makeSelectTopPlateColor = () =>
  createSelector(makeSelectLastHistoryCabinet(), (cabinet):
    | ColorPreviewItem
    | undefined => {
    if (cabinet.top && cabinet.top.plate) {
      return cabinet.top.plate.color;
    }
    return undefined;
  });

export const makeSelectIsGlassTopPlate = () =>
  createSelector(
    makeSelectLastHistoryCabinet(),
    (cabinet): boolean => cabinet.top && !!cabinet.top.glassPlate,
  );

export { selectCabinetRibbonDomain, makeSelectCabinetRibbon };
